
export const resolveProjectFilter = (nameProject, currentProject, projects) => {
  nameProject = nameProject?.length && nameProject[1] ? nameProject[1]?.trim() : currentProject;
  let codeProject = currentProject ? projects?.items?.find(
    (project) => project.name.includes(nameProject)
  ) : null;
  return codeProject?.ov_code
    ? codeProject?.ov_code
    : codeProject?.code;
};

export const getCustomProjectCodeIfIsOv = (project) => {
    return (
        project.code.includes('-') && project.code.includes('100')
          ? (
              (
                project.code.split('-').pop().trim().startsWith('OV')
                  ? project.code.split('-').pop().trim()
                  : 'OV' + project.code.split('-').pop().trim()
              ) + ' - ' + project.name
            )
          : `${project.code} - ${project.name}`
      )
}